import { useEffect } from 'react';
import type { ComponentProps } from 'react';
import { Controller } from 'react-hook-form';
import { get } from 'lodash-es';
import { useReferralFormContext } from '../../ReferralFormContext';
import { useWatch } from 'react-hook-form';
import SingleSelectField from '../../components/SingleSelectField';
import { FieldEnum, FieldMap } from '../sectionSchema';
import { SingleSelectFieldConfig } from '../types';

/** omit props that are controlled  by the form provider */
type PartialSingleSelectFieldProps = Omit<
  ComponentProps<typeof SingleSelectField>,
  'onChange' | 'onBlur' | 'value' | 'label'
>;

interface ControlledSolutionPlayFieldProps
  extends PartialSingleSelectFieldProps {
  name: string;
}

/** SolutionPlay field that iscontrolled by react-hook-form context
 *  Resets the value if the current value is not in the options provided
 */
const ControlledSolutionPlayField = ({
  name,
  ...fieldProps
}: ControlledSolutionPlayFieldProps) => {
  const { dataId, helperText, label, required } = FieldMap[
    name
  ] as SingleSelectFieldConfig;

  const { control, errors, setValue } = useReferralFormContext();

  const solutionPlayValue = useWatch<string>({
    name: FieldEnum.solutionPlay,
  });

  const errorMessage = get(errors, name)?.message;

  const options = fieldProps.options;

  useEffect(() => {
    if (
      solutionPlayValue &&
      !options?.some((x) => x.value === solutionPlayValue)
    ) {
      /** reset solutionPlay if current value is not in options */
      setValue(FieldEnum.solutionPlay, '');
    }
  }, [solutionPlayValue, setValue, options]);

  return (
    <Controller
      control={control}
      name={name}
      render={({ ref: _ref, value, onBlur, onChange }) => {
        return (
          <SingleSelectField
            {...fieldProps}
            dataId={dataId}
            helperText={helperText}
            label={label}
            required={required}
            errorMessage={errorMessage}
            name={name}
            onBlur={onBlur}
            onChange={onChange}
            value={value}
          />
        );
      }}
    />
  );
};
export default ControlledSolutionPlayField;
